<!--
Author: TangChen
Date: 2018-11-09
Desc: 用户持有银行卡信息组件，由index.js 配置引入
-->
<template>
    <div class="bizcomp-hold-bank">
        <div v-if="!embedded" class="bar-contain">
            <div class="bar"></div>
            <div class="bar-text">银行卡管理</div>
        </div>
        <div class="hold-bank-list-contain">
            <div
                v-for="(card, index) in bankCardList"
                :key="index"
                :class="[
                    'hold-bank-list',
                    { 'is-expand': card.expand },
                    index % 3 < 2 ? 'margin-right-25' : '',
                    index > 2 ? 'margin-top-16' : ''
                ]"
            >
                <div class="bank-card">
                    <!-- 卡头 -->
                    <div class="bank-info">
                        <div class="bank-img">
                            <img :src="$util.getImg(card.bankcode)" />
                        </div>
                        <div class="bank-name">
                            <span class="t">
                                {{ $cache.getDict("110080", card.bankcode) }}
                            </span>
                            <!-- 卡号 -->
                            <p class="bank-num">
                                {{ card.depositcard }}
                            </p>
                        </div>
                    </div>

                    <div class="bank-action-right">
                        <el-button
                            v-if="changeCardDisplay"
                            class="bank-outline-btn"
                            size="mini"
                            v-on:click="toChangeCard(card)"
                        >
                            换卡
                        </el-button>
                    </div>

                    <!-- 渠道列表 -->
                    <div class="pay-channel">
                        <div class="pay-channel-title">
                            <div
                                v-if="
                                    $cache.getSysParam('10113006') &&
                                    $cache.getSysParam('10113006') == '2' &&
                                    $util.remitOpen()
                                "
                                class="left"
                            >
                                <span
                                    class="transfer-action"
                                    v-on:click.stop="handleTransfer(card)"
                                >
                                    {{ card.hasTransfer ? "取消转账交易" : "开通转账交易" }}
                                </span>
                            </div>
                            <div
                                v-if="
                                    $cache.getSysParam('10113006') &&
                                    $cache.getSysParam('10113006') == '2'
                                "
                                class="divider"
                            ></div>
                            <div class="right" v-on:click="toggleExpand(card)">
                                付款渠道
                                <i class="el-icon-arrow-down" :class="{ rotate: card.expand }" />
                            </div>
                        </div>

                        <div v-show="card.expand" class="pay-channel-list">
                            <div
                                v-for="channel in card.channels"
                                :key="channel.transactionaccountid"
                                class="pay-channel-item"
                            >
                                <div class="left">
                                    <div class="name">
                                        {{ channel.paycentername }}
                                    </div>
                                    <div class="limit">
                                        单笔{{ $util.fmtNum(channel.maxbuysingle) }}， 单日{{
                                            $util.fmtNum(channel.perdaymax)
                                        }}
                                    </div>
                                </div>

                                <div class="right">
                                    <el-button
                                        v-if="
                                            !$util.isPersonalBuyBusinessDisabled() &&
                                            !channel.activeDisabledTip
                                        "
                                        type="primary"
                                        class="bank-btn"
                                        size="mini"
                                        v-on:click="activeHandle(channel)"
                                    >
                                        激活
                                    </el-button>

                                    <el-tooltip
                                        v-if="channel.canDelete"
                                        content="银行卡解绑即交易账户销户"
                                    >
                                        <i
                                            class="el-icon-delete"
                                            v-on:click="
                                                deleteBank(
                                                    channel.bankcardid,
                                                    channel.paycenterid,
                                                    undefined,
                                                    channel.hkcardflag === '1'
                                                )
                                            "
                                        ></i>
                                    </el-tooltip>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <div
                    v-if="!$util.getConfig().hideFunc && bankCardList.length === 0"
                    class="bank-card-add"
                >
                    <div class="img-text-contain">
                        <img class="no-card" src="@/assets/img/no-card.png" alt="" />
                        <p class="other">暂无可用银行卡</p>
                    </div>
                </div>
            </div>
            <div
                v-if="$util.getConfig().hideFunc && $util.getBusinessModule('0A3')"
                :class="'bank-card-add ' + (bankCardList.length > 2 ? 'margin-top-16' : '')"
                v-on:click="goAddBank"
            >
                <div class="img-text-contain">
                    <i
                        style="color: var(--color-primary); font-size: 22px"
                        class="el-icon-circle-plus"
                    ></i>
                    <p class="other">新增银行卡</p>
                </div>
            </div>
        </div>
        <div class="bar-contain">
            <div class="bar"></div>
            <div class="bar-text">可选银行</div>
        </div>
        <support-bank
            v-if="paychannelbankInfoList.length > 0"
            :paychannelbank-info-list="paychannelbankInfoList"
        ></support-bank>
        <warm-tips :content="warmTipsContent" />
        <el-dialog
            title="银行卡删除"
            :visible.sync="dialogVisible"
            class="prop info-tips"
            width="480px"
        >
            <div class="investor-tips">
                <div class="prompt-info">
                    <p>
                        <i class="el-icon-warning" aria-hidden="true" />
                        <span v-if="isTransferDelete">
                            确认取消尾号{{ deleteCardNo }}银行卡的转账交易功能？
                        </span>
                        <span v-else>该操作会进行交易账户销户操作，是否确认</span>
                    </p>
                </div>
                <el-form
                    ref="ruleForm"
                    class="two-cols-form"
                    :model="ruleForm"
                    :rules="rules"
                    label-width="37px"
                    size="small"
                >
                    <el-form-item v-if="isPwdCheck" label="" prop="tradepwd">
                        <el-input
                            v-model="ruleForm.tradepwd"
                            type="password"
                            :maxlength="20"
                            placeholder="请输入交易密码"
                        />
                        <span
                            class="redemp-btn"
                            v-on:click.prevent="$router.push({ name: 'tradepwd' })"
                        >
                            <span class="like-a">忘记密码？</span>
                        </span>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button v-on:click="dialogVisible = false">我再想想</el-button>
                <el-button type="primary" v-on:click="deleteBankCon(deleteId, payCenterId)">
                    确定取消
                </el-button>
            </div>
        </el-dialog>

        <el-dialog
            title="开通转账交易"
            :visible.sync="openTransferVisible"
            class="prop info-tips open-transfer-dialog"
            width="520px"
        >
            <div>
                <div class="prompt-info">
                    <i class="el-icon-warning" />
                    <span>您正在开通下面的银行转账交易功能：</span>
                </div>

                <div v-if="currentChannel && currentChannel.bankcode" class="bank-confirm">
                    <img :src="$util.getImg(currentChannel.bankcode)" />
                    <div class="bank-confirm-info">
                        <div class="bank-name">
                            {{ $cache.getDict("110080", currentChannel.bankcode) }}
                        </div>
                        <div class="bank-no">
                            {{ currentChannel.depositcard }}
                        </div>
                    </div>
                </div>

                <el-form
                    v-if="isTransferPwdCheck"
                    ref="openTransferForm"
                    :model="openTransferForm"
                    :rules="openTransferRules"
                    label-width="0"
                    class="pwd-form"
                >
                    <el-form-item prop="tradepwd" class="pwd-line">
                        <div class="pwd-row">
                            <el-input
                                v-model="openTransferForm.tradepwd"
                                type="password"
                                placeholder="请输入交易密码"
                            />
                            <span
                                class="forget-pwd"
                                v-on:click.prevent="$router.push({ name: 'tradepwd' })"
                            >
                                忘记密码？
                            </span>
                        </div>
                    </el-form-item>
                </el-form>
                <!-- ===== 协议 ===== -->
                <div class="agreement-container">
                    <agreement
                        :key="agreementKey"
                        ref="transferAgreement"
                        v-model="protocol"
                        :data="''"
                        :policytype="agrType"
                        v-on:all-read="agreePro"
                    ></agreement>
                </div>
            </div>

            <!-- ========== footer ========== -->
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" v-on:click="handleSubmit">申请开通</el-button>
            </div>
        </el-dialog>
        <el-dialog
            title="开通转账交易"
            :visible.sync="transferSuccessVisible"
            class="prop open-transfer-success-dialog"
            width="520px"
        >
            <div class="transfer-success">
                <div class="transfer-success-top">
                    <div class="success-icon">
                        <i class="el-icon-check"></i>
                    </div>

                    <h2 class="success-title">申请成功</h2>
                </div>

                <p class="success-sub">
                    {{ $cache.getCompanyInfoParam("10101001") }}转账交易指定收款账户
                </p>

                <ul class="success-info">
                    <li>
                        <span class="label">银行户名</span>
                        <span class="value">{{ successInfo.acctname }}</span>
                        <span class="copy" v-on:click="handleCopy(successInfo.acctname)">复制</span>
                    </li>
                    <li>
                        <span class="label">银行账号</span>
                        <span class="value">{{ successInfo.account }}</span>
                        <span class="copy" v-on:click="handleCopy(successInfo.account)">复制</span>
                    </li>
                    <li>
                        <span class="label">开户行</span>
                        <span class="value">{{ successInfo.bank }}</span>
                        <span class="copy" v-on:click="handleCopy(successInfo.bank)">复制</span>
                    </li>
                </ul>

                <el-button
                    type="primary"
                    class="buy-btn"
                    :class="{ 'is-disabled': $util.isPersonalBuyBusinessDisabled() }"
                    v-on:click="toBuyFund"
                >
                    去买基金
                </el-button>
            </div>
        </el-dialog>
        <el-dialog
            title="转账交易限制"
            :visible.sync="transferLimitVisible"
            class="prop info-tips"
            width="480px"
        >
            <div class="investor-tips">
                <div class="prompt-info">
                    <p>
                        <i class="el-icon-warning" aria-hidden="true" />
                        <span>
                            最多只支持开通{{
                                $cache.getParamValue("account_info") &&
                                $cache.getParamValue("account_info").addcardlimit != null
                                    ? $cache.getParamValue("account_info").addcardlimit
                                    : 3
                            }}张银行卡的转账交易功能
                        </span>
                    </p>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" v-on:click="transferLimitVisible = false">
                    我知道了
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import mixin from "@/assets/js/mixin";
import SupportBank from "@/bizcomponents/bank/supportBankDc.vue";
import userApi from "@/api/user";
import fundApi from "@/api/fund";
import commonApi from "@/api/common";
import warmTips from "@/components/common/warmTips.vue";
import agreement from "@/components/form/agreement.vue";
import { policyTypesEnum } from "@/util/util_jfit";

export default {
    name: "BankDc",
    components: {
        SupportBank,
        warmTips,
        agreement
    },
    mixins: [mixin],
    props: {
        embedded: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            bankInfo: [],
            dialogVisible: false,
            visible: false,
            isPwdCheck: false,
            ruleForm: {
                tradepwd: ""
            },
            rules: {
                tradepwd: [
                    {
                        required: true,
                        message: "请输入交易密码",
                        trigger: "blur"
                    }
                ]
            },
            deleteId: "",
            payCenterId: "",
            isTransferDelete: false, // 是否是转账交易删除
            deleteCardNo: "", // 删除的卡号
            totalasset: 0,
            paychannelbankInfoList: [],
            changeCardDisplay: true, // 换卡管理是否展示
            bankCardList: [], // 我的银行卡列表(同行同卡维度)
            warmTipsContent: "", // 接口返回的 HTML
            // ===== 开通转账交易弹窗 =====
            openTransferVisible: false,
            openTransferForm: {
                tradepwd: ""
            },
            openTransferRules: {
                tradepwd: [{ required: true, message: "请输入交易密码", trigger: "blur" }]
            },
            currentChannel: null, // 当前要开通的渠道
            protocol: false,
            protocolPass: false, // 是否真正“同意通过”
            successInfo: {
                acctname: "",
                account: "",
                bank: ""
            },
            isTransferPwdCheck: true, // 转账交易是否需要密码校验
            transferSuccessVisible: false,
            agrType: policyTypesEnum.transfer, // 协议类型，转账协议
            agreementKey: 0,
            transferLimitVisible: false // 转账交易限制弹窗
        };
    },
    watch: {
        openTransferVisible(val) {
            if (val) {
                // === 重置协议状态 ===
                this.protocol = false;
                this.protocolPass = false;

                //  核心：强制 agreement 重新创建
                this.agreementKey++;

                // 其他你原来的逻辑
                this.openTransferForm.tradepwd = "";
                this.$nextTick(() => {
                    this.$refs.openTransferForm && this.$refs.openTransferForm.resetFields();
                });

                this.$nextTick(() => {
                    const agr = this.$refs.transferAgreement;
                    agr && agr.getAgreement();
                });
            }
        }
    },
    mounted() {
        this.qryTipsConfig();
        this.getBankInfo();
        const accountInfo = this.$cache.getParamValue("account_info");
        if (accountInfo && accountInfo.showchangebankcard == false) {
            this.changeCardDisplay = false;
        }
    },
    methods: {
        goAddBank() {
            if (this.$util.checkAddBankBlocked()) return;
            this.$router.push({ name: "addbank" });
        },
        // 查询温馨提示
        async qryTipsConfig() {
            try {
                const res = await commonApi.qryTipsConfig({
                    tipstype1st: "1007",
                    tipstype2nd: "100701"
                });

                const list = res.data || [];
                if (list.length > 0) {
                    this.warmTipsContent = list[0].content || "";
                }
            } catch (e) {
                this.warmTipsContent = "";
            }
        },

        // 查询
        async getBankInfo() {
            if (!this.$cache.getBinded()) return;

            try {
                const { bankList, paychannelbankInfoList } = await userApi.getBankCardList();
                // 原始列表（如果你后面还用得到）
                this.bankInfo = bankList || [];

                // 右侧「可选银行」
                this.paychannelbankInfoList = paychannelbankInfoList || [];

                // 同卡多渠道聚合
                this.bankCardList = this.groupBankCards(this.bankInfo);
            } catch (e) {
                this.bankInfo = [];
                this.bankCardList = [];
                this.paychannelbankInfoList = [];
            }
        },
        //  核心方法：同卡多渠道合并
        groupBankCards(bankList) {
            const map = {};

            bankList.forEach((item) => {
                const key = `${item.bankcode}_${item.en_desendepositcard}`;

                if (!map[key]) {
                    map[key] = {
                        bankcode: item.bankcode,
                        depositcard: item.depositcard,
                        desendepositcard: item.desendepositcard,
                        en_desendepositcard: item.en_desendepositcard,
                        paycenterid: item.paycenterid,
                        identifytype: item.identifytype,
                        channels: [],
                        canChange: item.hkcardflag !== "1", // === 换卡 ===
                        expand: false // 是否展开渠道
                    };
                }

                map[key].channels.push({
                    bankcode: item.bankcode,
                    bankcardid: item.bankcardid,
                    paycenterid: item.paycenterid,
                    paycentername: this.$cache.getDict("110079", item.paycenterid),
                    transactionaccountid: item.transactionaccountid,
                    en_desendepositcard: item.en_desendepositcard,
                    authenticateflag: item.authenticateflag,
                    hkcardflag: item.hkcardflag,

                    maxbuysingle: item.maxbuysingle || "--",
                    perdaymax: item.perdaymax || "--",

                    canActive: item.hkcardflag !== "1" && item.authenticateflag !== "1",
                    // === 激活 ===
                    activeDisabledTip:
                        item.hkcardflag === "1"
                            ? "汇款模式卡不支持激活"
                            : item.authenticateflag === "1"
                            ? "银行卡已激活"
                            : "",

                    // === 解绑 ===
                    canDelete: this.$util.getBusinessModule("0B6")
                });
            });

            return Object.values(map).map((card) => {
                const hasTransfer = card.channels.some((c) => c.hkcardflag === "1");

                return {
                    ...card,
                    hasTransfer, // 是否已开通转账交易
                    canChange: !hasTransfer // 是否允许换卡（示例）
                };
            });
        },
        // 只展开一张银行卡
        toggleExpand(currentCard) {
            this.bankCardList.forEach((card) => {
                if (card === currentCard) {
                    card.expand = !card.expand; // 当前点击的切换
                } else {
                    card.expand = false; // 其他全部收起
                }
            });
        },
        // 换卡
        async toChangeCard(bankInfo) {
            // if (!bankInfo.hasTransfer) {
            //     this.$message.warning(
            //         "为保障您的账户安全，换卡业务只针对开通了线上支付的银行卡开放！"
            //     );
            //     return;
            // }

            const params = { paychannel: bankInfo.paycenterid };
            if (this.$cache.getIsEncrypted()) {
                params.en_depositcard = bankInfo.en_desendepositcard;
            } else {
                params.depositcard = bankInfo.desendepositcard;
            }
            const preRes = await userApi.combBankCardPrepare(params, this.$cache.getIsEncrypted());
            if (preRes && preRes.data) {
                if (preRes.data.fourpermissionflag == 0) {
                    this.$message.warning("该银行卡不允许换卡！");
                    return;
                }
                if (preRes.data.fourpermissionflag == 1 && preRes.data.haspermissionflag == 1) {
                    bankInfo.needFile = 0;
                    bankInfo.bankcardid =
                        bankInfo.channels.length > 0 ? bankInfo.channels[0].bankcardid : "";
                    bankInfo.paychannel = (bankInfo.channels || [])
                        .map((item) => item.paycenterid)
                        .join(",");
                    this.$router.push({
                        name: "changecard",
                        query: bankInfo
                    });
                } else {
                    this.$message.warning("该银行卡不允许换卡！");
                    // bankInfo.needFile = 1;
                    // const res = await fundApi.getHoldingAssets({});
                    // if (res.data && res.data.first) {
                    //     this.totalasset = res.data.first.totalasset || 0;
                    //     if (Number(this.totalasset) > 100000) {
                    //         this.$message.warning("该银行卡不允许换卡！");
                    //     } else {
                    //         this.$router.push({
                    //             name: "changecard",
                    //             query: bankInfo
                    //         });
                    //     }
                    // }
                }
            }
        },
        // 解绑
        deleteBank(id, payCenterId, signstatus, isTransferDelete = false) {
            // if ((payCenterId == "0103" || payCenterId == "0113") && signstatus == "1") {
            //     this.$alert("该银行卡需解约后才能进行解绑操作！", "", {
            //         confirmButtonText: "确定",
            //         type: "warning",
            //         callback: (action) => {
            //             if (action == "confirm") {
            //                 this.$router.push({ name: "signandunsign" });
            //             }
            //         }
            //     });
            //     return;
            // }
            this.deleteId = id;
            this.payCenterId = payCenterId;

            // 是否转账交易以 hkcardflag 为准，避免用 0001/XSHK 等渠道号反推业务类型。
            this.isTransferDelete = isTransferDelete;

            // 如果是转账交易，获取卡号后四位
            if (this.isTransferDelete) {
                const card = this.bankCardList.find((c) =>
                    c.channels.some((ch) => ch.bankcardid === id && ch.paycenterid === payCenterId)
                );
                this.deleteCardNo = card ? card.depositcard.slice(-4) : "";
            }

            this.dialogVisible = true;
            this.$util.queryValidPwdTrdMethod("0B6", (res) => {
                this.isPwdCheck = res;
                if (this.$refs.ruleForm) {
                    this.$refs.ruleForm.resetFields();
                }
            });
        },
        deleteBankCon(id, payCenterId) {
            const _this = this;
            this.$refs.ruleForm.validate(async (valid) => {
                if (valid) {
                    _this.dialogVisible = false;
                    const params = {
                        bankcardid: id
                    };
                    if (_this.isPwdCheck) {
                        params.tradepassword = _this.$util.enc(_this.ruleForm.tradepwd);
                    }
                    const res = await userApi.delBankCard(params);
                    if (res.code === "0") {
                        _this.dialogVisible = false;
                        _this.getBankInfo();
                        _this.$message({
                            type: "success",
                            message: "银行卡删除成功!"
                        });
                    }
                } else {
                    return false;
                }
            });
        },

        openTransferDialog(card) {
            this.currentChannel = card;
            this.openTransferVisible = true;
            this.$util.queryValidPwdTrdMethod("0C7", (res) => {
                this.isTransferPwdCheck = res;
            });
        },

        confirmOpenTransfer() {
            if (!this.protocolPass) {
                this.$message.warning("请先阅读并勾选相关协议");
                return;
            }
            if (this.isTransferPwdCheck) {
                this.$refs.openTransferForm.validate((valid) => {
                    if (!valid) {
                        this.$message.warning("请输入交易密码");
                        return;
                    }
                    this.doConfirmOpenTransfer();
                });
            } else {
                this.doConfirmOpenTransfer();
            }
        },

        async doConfirmOpenTransfer() {
            const channel = this.currentChannel.channels.find((c) => c.hkcardflag != "1");

            if (!channel) return;

            const params = {
                bankcardid: channel.bankcardid,
                paychannel: this.$util.getRemitTradePayChannel()
            };

            if (this.isTransferPwdCheck) {
                params.tradepassword = this.$util.enc(this.openTransferForm.tradepwd);
            }

            try {
                const res = await userApi.addPaychannel(params);

                if (res.code === "0") {
                    // 查询汇款账户信息
                    const hkInfo = await this.queryHkAccountInfo({ paychannel: params.paychannel });

                    if (hkInfo) {
                        this.successInfo = hkInfo;
                    } else {
                        // 兜底：至少不阻断成功流程
                        this.successInfo = {
                            acctname: "",
                            account: "",
                            bank: ""
                        };
                    }
                    this.openTransferVisible = false;
                    this.transferSuccessVisible = true; // 打开成功弹窗
                    this.getBankInfo();
                }
            } catch (e) {
                this.$message.error("开通转账交易失败，请稍后重试");
            }
        },

        toBuyFund() {
            if (this.$util.checkPersonalBuyBusinessDisabled("认申购")) return;
            this.openTransferVisible = false;
            this.$router.push({ name: "fund" });
        },

        // 激活
        activeHandle(channel) {
            if (this.$util.isPersonalBuyBusinessDisabled()) return;
            this.$router.push({
                name: "activebank",
                query: { id: channel.bankcardid }
            });
        },
        cancelTransfer(card) {
            // 找到 hkcardflag = 1 的那条渠道
            const channel = card.channels.find((c) => c.hkcardflag === "1");

            if (!channel) {
                this.$message.warning("未找到可取消的转账交易渠道");
                return;
            }

            // 直接复用 deleteBank
            this.deleteBank(channel.bankcardid, channel.paycenterid, undefined, true);
        },
        // 统一处理转账交易
        handleTransfer(card) {
            if (card.hasTransfer) {
                // 已开通 → 取消
                this.cancelTransfer(card);
            } else {
                // 未开通 → 检查限制
                const transferCount = this.bankCardList.filter((c) => c.hasTransfer).length;
                const accountInfo = this.$cache.getParamValue("account_info");
                const addcardlimit =
                    accountInfo && accountInfo.addcardlimit != null
                        ? accountInfo.addcardlimit
                        : null;
                if (addcardlimit !== null && transferCount >= addcardlimit) {
                    this.transferLimitVisible = true;
                    return;
                }
                this.openTransferDialog(card);
            }
        },
        handleSubmit() {
            // 关键：先重置，再触发，保证 watch 一定执行
            this.protocol = false;

            this.$nextTick(() => {
                this.protocol = true;
            });
        },
        agreePro(val) {
            this.protocolPass = val;

            if (!val) {
                // 没勾协议，agreement 里已经 alert 过了
                return;
            }

            // 协议 OK，继续密码 & 提交
            this.confirmOpenTransfer();
        },
        async queryHkAccountInfo(channel) {
            try {
                const { data } = await userApi.getInfoByPaychannel({
                    paychannel: channel.paychannel || channel.paycenterid
                });

                let hkBankArray = [];

                if (data.cfgSpecacctinfoList) {
                    // accttype: 0-收款 1-付款 2-收付款
                    hkBankArray = (data.cfgSpecacctinfoList || []).filter(
                        (item) => item.accttype === "0" || item.accttype === "2"
                    );
                }

                if (hkBankArray.length === 0) {
                    this.$message.info("未查询到汇款账户信息");
                    return null;
                }

                return {
                    acctname: hkBankArray[0].acctname,
                    account: hkBankArray[0].acctcode,
                    bank: hkBankArray[0].bankname
                };
            } catch (e) {
                this.$message.error("查询汇款账户信息失败");
                return null;
            }
        },
        handleCopy(text) {
            this.$util.copyText(this, text);
        }
    }
};
</script>
<style scoped lang="scss">
/* ===============================
 * 用户持有银行卡信息
 * =============================== */
.bizcomp-hold-bank {
    overflow: hidden;

    /* ---------- 弹窗 ---------- */
    .info-tips {
        .two-cols-form .el-form-item__content .el-input {
            width: 70%;
        }

        .prompt-info {
            .el-icon-warning {
                color: var(--color-primary);
                margin-right: 8px;
                font-size: $f24;
                vertical-align: middle;
            }

            span {
                vertical-align: middle;
            }
        }
    }

    .redemp-btn {
        margin-left: 3%;
    }

    /* ---------- 标题条 ---------- */
    .bar-contain {
        display: flex;
        align-items: center;
        margin: 36px 0 16px;

        &:first-child {
            margin-top: 0;
        }

        .bar {
            width: 4px;
            height: 16px;
            background: var(--color-primary);
        }

        .bar-text {
            margin-left: 6px;
            font-size: 18px;
            font-weight: 500;
            color: var(--color-text-primary);
        }
    }

    /* ---------- 银行卡列表容器 ---------- */
    .hold-bank-list-contain {
        display: flex;
        flex-wrap: wrap;
        margin-top: 16px;
        box-sizing: border-box;
        overflow: visible;

        /* 新增 / 空卡片 */
        .bank-card-add {
            width: 370px;
            height: 180px;
            border-radius: 8px;
            background: var(--color-bg-page);
            box-sizing: border-box;
            border: 1px solid var(--color-divided);
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;

            .img-text-contain {
                display: flex;
                align-items: center;
            }

            .no-card {
                width: 36px;
                height: 36px;
                border-radius: 50%;
            }

            .other {
                margin-left: 6px;
                font-size: 16px;
                font-weight: normal;
                color: var(--color-primary);
            }
        }
    }

    /* ---------- 单张银行卡 ---------- */
    .hold-bank-list {
        position: relative;
        z-index: 1;

        &.is-expand {
            z-index: 10; // 展开时压住其他卡
        }

        .bank-card {
            position: relative;
            width: 370px;
            min-height: 180px;
            border-radius: 8px;
            opacity: 1;
            background: linear-gradient(
                296deg,
                color-mix(in srgb, var(--color-primary) 90%, white) 1%,
                color-mix(in srgb, var(--color-primary) 85%, black) 100%
            );
            .bank-info {
                display: flex;
                padding: 16px;
                padding-bottom: 0;

                .bank-img {
                    width: 50px;
                    height: 50px;
                    padding: 7px;
                    border-radius: 50%;
                    background: var(--color-bg-page);
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    img {
                        width: 36px;
                        height: 36px;
                        border-radius: 50%;
                    }
                }

                .bank-name {
                    margin-left: 10px;

                    .t {
                        font-size: 18px;
                        font-weight: bold;
                        color: var(--color-bg-page);
                    }
                }
            }

            .bank-num {
                height: 30px;
                text-align: center;
                font-size: 14px;
                color: var(--color-bg-page);
            }
        }
    }

    /* ---------- 右上操作按钮 ---------- */
    .bank-action-right {
        position: absolute;
        top: 90px;
        right: 16px;
        display: flex;
        gap: 8px;
        z-index: 5;
    }

    .bank-outline-btn {
        background: transparent !important;
        border: 1px solid var(--color-bg-page) !important;
        color: var(--color-bg-page) !important;
        padding: 6px 21px;
        font-size: 14px;
        border-radius: 2px;

        &:hover,
        &:focus {
            background: rgba(255, 255, 255, 0.15) !important;
        }

        &:active {
            background: rgba(255, 255, 255, 0.25) !important;
        }
    }

    /* ---------- 付款渠道 ---------- */
    .pay-channel {
        position: absolute;
        bottom: 0;
        width: 100%;
        z-index: 10;
        color: var(--color-bg-page);

        .pay-channel-title {
            display: flex;
            align-items: center;
            height: 42px;
            font-size: 14px;
            background: rgba(0, 0, 0, 0.2);
            user-select: none;

            .left,
            .right {
                flex: 1;
                display: flex;
                align-items: center;
                justify-content: center;
            }

            .left {
                cursor: pointer;

                .transfer-action {
                    opacity: 0.9;

                    &:hover {
                        opacity: 1;
                        text-decoration: underline;
                    }
                }
            }

            .divider {
                width: 1px;
                height: 18px;
                background: rgba(255, 255, 255, 0.6);
            }

            .right {
                cursor: pointer;

                .el-icon-arrow-down {
                    margin-left: 6px;
                    transition: transform 0.2s;
                }

                .rotate {
                    transform: rotate(180deg);
                }
            }
        }
    }

    .pay-channel-list {
        position: absolute;
        top: 42px;
        left: 0;
        width: 100%;
        z-index: 20;
        padding: 8px 12px;
        background: var(--color-bg-page);
        color: var(--color-text-regular);
        max-height: 240px;
        overflow-y: auto;
        border-radius: 6px;
        border: 1px solid var(--color-divided);
        box-shadow: 0 6px 18px rgba(0, 0, 0, 0.15);
        box-sizing: border-box;

        .pay-channel-item {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 12px 0;
            border-bottom: 1px solid var(--color-bg-page);

            &:last-child {
                border-bottom: none;
            }

            .name {
                font-size: 15px;
                color: var(--color-text-primary);
                margin-bottom: 8px;
            }

            .limit {
                font-size: 12px;
                color: var(--color-text-accent);
                width: 205px;
            }
        }

        .el-icon-delete {
            margin-left: 10px;
            cursor: pointer;
        }
    }

    /* ---------- 工具类 ---------- */
    .margin-top-16 {
        margin-top: 16px;
    }

    .margin-right-25 {
        margin-right: 25px;
    }

    .open-transfer-dialog {
        .bank-confirm {
            display: flex;
            align-items: center;
            margin: 20px 0;

            img {
                width: 40px;
                height: 40px;
                margin-right: 12px;
            }

            .bank-name {
                font-size: 16px;
                font-weight: 500;
            }

            .bank-no {
                color: var(--color-text-accent);
                margin-top: 4px;
            }
        }

        .pwd-form {
            margin-bottom: 20px;
        }

        .pwd-line {
            margin-bottom: 0;

            .pwd-row {
                display: flex;
                align-items: center;
                gap: 12px;

                .el-input {
                    flex: 1;
                    min-width: 0;
                }

                .forget-pwd {
                    color: var(--color-primary);
                    cursor: pointer;
                    white-space: nowrap;
                    font-size: 13px;
                    flex-shrink: 0;

                    &:hover {
                        text-decoration: underline;
                    }
                }
            }
        }

        .agreement-container {
            .comp-agreement {
                margin-left: -2px !important;
                margin-top: 0 !important;
            }
        }
    }

    /* ===== 转账交易成功弹窗 ===== */
    .open-transfer-success-dialog {
        :deep(.el-dialog__body) {
            padding: 32px 24px 40px;
        }
    }

    .transfer-success {
        text-align: center;
        .transfer-success-top {
            display: flex;
            margin-left: 15px;
            align-items: center;
            margin-bottom: 20px;
            text-align: justify;
        }

        .success-icon {
            width: 64px;
            height: 64px;
            // margin: 0 auto;
            margin-right: 30px;
            border-radius: 50%;
            background: var(--color-success);
            display: flex;
            align-items: center;
            justify-content: center;

            i {
                color: var(--color-bg-page);
                font-size: 36px;
                font-weight: bold;
            }
        }

        .success-title {
            margin: 16px 0 8px;
            font-size: 30px;
            font-weight: 500;
            color: var(--color-text-primary);
        }

        .success-sub {
            text-align: justify;
            font-size: 14px;
            color: var(--color-text-accent);
            margin-bottom: 24px;
            margin-left: 15px;
        }

        .success-info {
            text-align: left;
            margin: 0 16px 28px;
            padding: 0;
            list-style: none;

            li {
                display: flex;
                align-items: center;
                padding: 10px 0;
                border-bottom: 1px solid var(--color-divided);
                font-size: 14px;

                &:last-child {
                    border-bottom: none;
                }

                .label {
                    width: 80px;
                    color: var(--color-text-accent);
                    flex-shrink: 0;
                }

                .value {
                    flex: 1;
                    color: var(--color-text-primary);
                    word-break: break-all;
                    padding-right: 8px;
                }

                .copy {
                    color: var(--color-primary);
                    cursor: pointer;
                    white-space: nowrap;

                    &:hover {
                        text-decoration: underline;
                    }
                }
            }
        }

        .buy-btn {
            width: 260px;
            height: 44px;
            font-size: 16px;
            border-radius: 4px;
        }
    }
}
</style>
